export const RESPONSE_ERROR_CODES = {
    // The category of errors for handling
    Type: 'AuthErrors',
    // Expired as seen on /userportalgateway/api/v1/UserProfiles
    ExpiredToken: 'ExpiredToken',
    // Tampered as seen on /userportalgateway/api/v1/UserProfiles
    TamperedToken: 'TamperedToken',
    // Use in the frontend when trying to make a request without one
    MissingToken: 'MissingToken'
};

export const RESPONSE_STATUS_CODES = {
    // ExpiredToken has this http status code
    SESSION_EXPIRED: 401,
    NOT_FOUND: 404
};
